import React, { ElementType, ReactNode, VFC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MuiSelect from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { IconProps } from '@material-ui/core/Icon';
import { SEARCH_COMPONENT_COLOR } from '../constants';

const useStyles = makeStyles({
  formControlRoot: {
    backgroundColor: 'white',
    border: `${SEARCH_COMPONENT_COLOR} 1px solid`,
    borderRadius: '40px',
    // 本来はそれぞれのclassesの要素に対してCSSを適用したいが、
    // classesのAPIで用意されていないためにこのような書き方をしている
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  inputLabelRoot: {
    color: SEARCH_COMPONENT_COLOR,
  },
  inputLabelFocused: {
    marginLeft: '4px',
    backgroundColor: 'white',
  },
  inputLabelShrink: {
    backgroundColor: 'white',
  },
  // 違和感のある記述だが、selectコンポーネントのclasses > selectに対してCSSを当てている
  selectSelect: {
    '&:focus': {
      backgroundColor: 'unset',
    },
  },
  iconRoot: {
    marginRight: '10px',
  },
});

interface Props {
  name: string;
  value: string | number;
  StartIcon: ElementType<IconProps>;
  label: ReactNode;
  options: { id: number; name: string }[];
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}
const Select: VFC<Props> = ({
  name,
  value,
  StartIcon,
  label,
  options,
  onChange,
}: Props) => {
  const {
    formControlRoot,
    inputLabelRoot,
    inputLabelFocused,
    inputLabelShrink,
    selectSelect,
    iconRoot,
  } = useStyles();
  return (
    <FormControl
      size="small"
      variant="outlined"
      fullWidth
      classes={{ root: formControlRoot }}
    >
      <InputLabel
        id={`${name}-label`}
        classes={{
          root: inputLabelRoot,
          focused: inputLabelFocused,
          shrink: inputLabelShrink,
        }}
      >
        <StartIcon fontSize="small" classes={{ root: iconRoot }} />
        {label}
      </InputLabel>
      <MuiSelect
        labelId={`${name}-label`}
        value={value}
        onChange={onChange}
        classes={{ select: selectSelect }}
        inputProps={{
          name,
          id: name,
        }}
      >
        <MenuItem aria-label="None" value="" />
        {options.map(({ id, name }) => (
          <MenuItem key={id} aria-label="None" value={id}>
            {name}
          </MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  );
};

export default Select;
